import React, { useState } from "react";
import { Card, CardHeader, CardTitle } from "../ui/card";

interface ImageWidgetProps {
  id: string;
  title: string;
  url?: string;
  instanceId?: string;
}

const ImageWidget: React.FC<ImageWidgetProps> = ({ title, url }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [error, setError] = useState(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const handleImageError = () => {
    setError(true);
  };

  return (
    <Card className="overflow-hidden h-full">
      <div className="relative w-full">
        {!imageLoaded && !error && (
          <div className="absolute inset-0 bg-muted animate-pulse flex items-center justify-center">
            <span className="text-muted-foreground text-sm">Afbeelding laden...</span>
          </div>
        )}
        
        {error && (
          <div className="absolute inset-0 bg-muted flex items-center justify-center">
            <span className="text-muted-foreground text-sm">Kan afbeelding niet laden</span>
          </div>
        )}
        
        <div className="w-full">
          <img 
            src={url} 
            alt={title}
            className={`w-full transition-opacity duration-300 ${imageLoaded ? 'opacity-100' : 'opacity-0'}`}
            onLoad={handleImageLoad}
            onError={handleImageError}
          />
        </div>
        
        {/* Gradient overlay for title */}
        <div className="absolute top-0 left-0 right-0 bg-gradient-to-b from-black/70 via-black/30 to-transparent h-20 z-10"></div>
        
        {/* Title on top of image */}
        <CardHeader className="absolute top-0 left-0 right-0 z-20 pb-2">
          <CardTitle className="text-white drop-shadow-md">{title}</CardTitle>
        </CardHeader>
      </div>
    </Card>
  );
};

export default ImageWidget; 